import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const getFonts = async () => {
  return await axios
    .get(`${BASE_URL}text-fonts-uploads`)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error getFonts', error.response.data)
      return error
    })
}

export const getAllFonts = async () => {
  return await axios
    .get(`${BASE_URL}text-fonts`)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear()
        // window.location.reload()
      }
      console.log('error getFonts', error.response.data)
      return error
    })
}

export const getFontTypes = async () => {
  return await axios
    .get(`${BASE_URL}text-fonts-type`)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear();
        // window.location.reload();
      }
      console.log('error getFonts', error.response.data)
      return error
    })
}

export const getAllExternalFonts = async () => {
  return await axios
    .get(`${BASE_URL}text-fonts-uploads`)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear();
        // window.location.reload();
      }
      console.log('error getAllExternalFontTypes', error.response.data)
      return error
    })
}

export const postExternalFonts = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .post(`${BASE_URL}text-fonts-uploads`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear();
        // window.location.reload();
      }
      console.log('error postExternalFonts', error.response.data)
      return error
    })
}

export const putExternalFonts = async (uuid, body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .put(`${BASE_URL}text-fonts-uploads/${uuid}`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear();
        // window.location.reload();
      }
      console.log('error putExternalFonts', error.response.data)
      return error
    })
}

export const postExternalFontsGoogle = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))
  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }
  return await axios
    .post(`${BASE_URL}text-fonts`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        // window.localStorage.clear();
        // window.location.reload();
      }
      console.log('error postExternalFonts', error.response.data)
      return error
    })
}
export const textFontById = async (id) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}text-fonts/${id}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error textFontById', error.response.data)
      return error
    })
}
